import { render, staticRenderFns } from "./Tax-Index.vue?vue&type=template&id=a2388a0a&"
import script from "./Tax-Index.vue?vue&type=script&lang=js&"
export * from "./Tax-Index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports